// removed by extract-text-webpack-plugin
module.exports = {"poster-list-wrapper":"poster-list-wrapper","poster-list":"poster-list"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Poster/PosterList/PosterList.scss
// module id = xBPE
// module chunks = 0